<script setup lang="ts">
import type SiteMessage from '@store/content/entities/SiteMessage';

const { message } = defineProps<{
    message: SiteMessage;
}>();

const contentStore = useContentStore();

const isClosable = computed(
    () => !!message?.closeAction && message?.closeAction !== 'none'
);

const close = () => {
    if (isClosable.value && message) {
        contentStore.closeMessage(message);
    }
};

onMounted(() => {
    if (message) {
        contentStore.shownMessage(message);
    }
});

onBeforeUnmount(() => {
    if (message) {
        contentStore.readMessage(message);
    }
});
</script>

<template>
    <mr-flash-message
        :is-closable
        :items="[{ message: message.text, iconImg: message.icon?.src }]"
        @close="close"
    />
</template>
